var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: "address address-align-" + _vm.localAlign }, [
    !_vm.editingFieldLabel
      ? _c(
          "label",
          {
            staticClass: "field-label",
            attrs: { for: "address" },
            on: { click: _vm.focusFieldLabel },
          },
          [
            _vm._v(
              "\n        " + _vm._s(_vm.displayFieldAddress) + "\n        "
            ),
            _vm.isRequired
              ? _c("span", { staticClass: "required-indicator" }, [_vm._v("*")])
              : _vm._e(),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.editingFieldLabel
      ? _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localFieldAddress,
              expression: "localFieldAddress",
            },
          ],
          ref: "fieldLabelInput",
          staticClass: "field-label-input",
          attrs: { type: "text", placeholder: "Adres" },
          domProps: { value: _vm.localFieldAddress },
          on: {
            blur: _vm.stopEditingFieldLabel,
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.stopEditingFieldLabel.apply(null, arguments)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localFieldAddress = $event.target.value
            },
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "inputs-container" }, [
      _c(
        "div",
        { class: ["input-wrapper", { filled: _vm.addressLine1Value }] },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addressLine1Value,
                expression: "addressLine1Value",
              },
            ],
            class: { "has-value": _vm.addressLine1Value },
            attrs: { type: "text", id: "address1", name: "address1" },
            domProps: { value: _vm.addressLine1Value },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.addressLine1Value = $event.target.value
                },
                _vm.updateField,
              ],
              focus: _vm.onFocus,
              blur: _vm.onBlur,
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "floating-label", attrs: { for: "address1" } },
            [_vm._v(_vm._s(_vm.localAddressLine1 || "Adres Satırı 1"))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-border" }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: ["input-wrapper", { filled: _vm.addressLine2Value }] },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.addressLine2Value,
                expression: "addressLine2Value",
              },
            ],
            class: { "has-value": _vm.addressLine2Value },
            attrs: { type: "text", id: "address2", name: "address2" },
            domProps: { value: _vm.addressLine2Value },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.addressLine2Value = $event.target.value
                },
                _vm.updateField,
              ],
              focus: _vm.onFocus,
              blur: _vm.onBlur,
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            { staticClass: "floating-label", attrs: { for: "address2" } },
            [_vm._v(_vm._s(_vm.localAddressLine2 || "Adres Satırı 2"))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-border" }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-wrapper-two" }, [
        _c(
          "div",
          { class: ["input-wrapper-half", { filled: _vm.cityValue }] },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.cityValue,
                  expression: "cityValue",
                },
              ],
              class: { "has-value": _vm.cityValue },
              attrs: { type: "text", id: "city", name: "city" },
              domProps: { value: _vm.cityValue },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.cityValue = $event.target.value
                  },
                  _vm.updateField,
                ],
                focus: _vm.onFocus,
                blur: _vm.onBlur,
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "floating-label", attrs: { for: "city" } },
              [_vm._v(_vm._s(_vm.localDistrict || "İlçe"))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-border" }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: ["input-wrapper-half", { filled: _vm.stateValue }] },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.stateValue,
                  expression: "stateValue",
                },
              ],
              class: { "has-value": _vm.stateValue },
              attrs: { type: "text", id: "state", name: "state" },
              domProps: { value: _vm.stateValue },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.stateValue = $event.target.value
                  },
                  _vm.updateField,
                ],
                focus: _vm.onFocus,
                blur: _vm.onBlur,
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "floating-label", attrs: { for: "state" } },
              [_vm._v(_vm._s(_vm.localState || "Şehir"))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-border" }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { class: ["input-wrapper", { filled: _vm.postalCodeValue }] }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.postalCodeValue,
              expression: "postalCodeValue",
            },
          ],
          class: { "has-value": _vm.postalCodeValue },
          attrs: { type: "text", id: "postalcode", name: "postalcode" },
          domProps: { value: _vm.postalCodeValue },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.postalCodeValue = $event.target.value
              },
              _vm.updateField,
            ],
            focus: _vm.onFocus,
            blur: _vm.onBlur,
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          { staticClass: "floating-label", attrs: { for: "postalcode" } },
          [_vm._v(_vm._s(_vm.localPostalCode || "Posta Kodu"))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "input-border" }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }